import React from 'react';

import { createStyles } from '../tss';

const useStyles = createStyles(() => ({
  root: {
    transition: 'width 300ms ease',
  },
  container: {
    height: '100%',
  },
}));

interface Props {
  children: React.ReactNode;
  className?: string;
  classes?: Partial<ReturnType<typeof useStyles>['classes']>;
  open: boolean;
  width: number;
  unmountOnExit?: boolean;
}

export const HorizontalCollapse: React.FC<Props> = ({
  children,
  classes: classesOverrides,
  className,
  open,
  width,
  unmountOnExit,
}) => {
  const { classes, cx } = useStyles({ classesOverrides });
  return (
    <div className={cx(classes.root, className)} style={{ width: open ? width : 0 }}>
      <div className={classes.container} style={{ width }}>
        {(open || !unmountOnExit) && children}
      </div>
    </div>
  );
};
